/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PccE2eFixtureResetAdvancedDetailsRequest } from './PccE2eFixtureResetAdvancedDetailsRequest';
import {
    instanceOfPccE2eFixtureResetAdvancedDetailsRequest,
    PccE2eFixtureResetAdvancedDetailsRequestFromJSON,
    PccE2eFixtureResetAdvancedDetailsRequestFromJSONTyped,
    PccE2eFixtureResetAdvancedDetailsRequestToJSON,
} from './PccE2eFixtureResetAdvancedDetailsRequest';
import type { PccE2eFixtureResetDocumentsByExactTuplesRequest } from './PccE2eFixtureResetDocumentsByExactTuplesRequest';
import {
    instanceOfPccE2eFixtureResetDocumentsByExactTuplesRequest,
    PccE2eFixtureResetDocumentsByExactTuplesRequestFromJSON,
    PccE2eFixtureResetDocumentsByExactTuplesRequestFromJSONTyped,
    PccE2eFixtureResetDocumentsByExactTuplesRequestToJSON,
} from './PccE2eFixtureResetDocumentsByExactTuplesRequest';
import type { PccE2eFixtureResetDocumentsByRelationTypeRequest } from './PccE2eFixtureResetDocumentsByRelationTypeRequest';
import {
    instanceOfPccE2eFixtureResetDocumentsByRelationTypeRequest,
    PccE2eFixtureResetDocumentsByRelationTypeRequestFromJSON,
    PccE2eFixtureResetDocumentsByRelationTypeRequestFromJSONTyped,
    PccE2eFixtureResetDocumentsByRelationTypeRequestToJSON,
} from './PccE2eFixtureResetDocumentsByRelationTypeRequest';

/**
 * @type PccE2eFixtureResetRequest
 * 
 * @export
 */
export type PccE2eFixtureResetRequest = PccE2eFixtureResetAdvancedDetailsRequest | PccE2eFixtureResetDocumentsByExactTuplesRequest | PccE2eFixtureResetDocumentsByRelationTypeRequest;

export function PccE2eFixtureResetRequestFromJSON(json: any): PccE2eFixtureResetRequest {
    return PccE2eFixtureResetRequestFromJSONTyped(json, false);
}

export function PccE2eFixtureResetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccE2eFixtureResetRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return { ...PccE2eFixtureResetAdvancedDetailsRequestFromJSONTyped(json, true), ...PccE2eFixtureResetDocumentsByExactTuplesRequestFromJSONTyped(json, true), ...PccE2eFixtureResetDocumentsByRelationTypeRequestFromJSONTyped(json, true) };
}

export function PccE2eFixtureResetRequestToJSON(value?: PccE2eFixtureResetRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfPccE2eFixtureResetAdvancedDetailsRequest(value)) {
        return PccE2eFixtureResetAdvancedDetailsRequestToJSON(value as PccE2eFixtureResetAdvancedDetailsRequest);
    }
    if (instanceOfPccE2eFixtureResetDocumentsByExactTuplesRequest(value)) {
        return PccE2eFixtureResetDocumentsByExactTuplesRequestToJSON(value as PccE2eFixtureResetDocumentsByExactTuplesRequest);
    }
    if (instanceOfPccE2eFixtureResetDocumentsByRelationTypeRequest(value)) {
        return PccE2eFixtureResetDocumentsByRelationTypeRequestToJSON(value as PccE2eFixtureResetDocumentsByRelationTypeRequest);
    }

    return {};
}

